import React from 'react'
import Hadear1 from './layout/Hadear1'
import Footer from './layout/Footer'
import { Outlet } from 'react-router-dom';
import WhatsappIcon from '../pages/WhatsappIcon';

const MainLayOut = () => {
  return (
    <>
      <Hadear1 />
      <Outlet />
      <WhatsappIcon />
      <Footer />
    </>
  );
}

export default MainLayOut